<bit-simple-dialog>
  <span bitDialogTitle>
    {{ (permanent ? "permanentlyDeleteSelected" : "deleteSelected") | i18n }}
  </span>
  <span bitDialogContent>
    <ng-container *ngIf="!permanent">
      <span *ngIf="cipherIds?.length || unassignedCiphers?.length">
        {{ "deleteSelectedItemsDesc" | i18n: cipherIds.length + unassignedCiphers.length }}
      </span>
      <span *ngIf="collections?.length">
        {{ "deleteSelectedCollectionsDesc" | i18n: collections.length }}
      </span>
      {{ "deleteSelectedConfirmation" | i18n }}
    </ng-container>
    <ng-container *ngIf="permanent">
      {{ "permanentlyDeleteSelectedItemsDesc" | i18n: cipherIds.length + unassignedCiphers.length }}
    </ng-container>
  </span>
  <ng-container bitDialogFooter>
    <button bitButton type="submit" buttonType="danger" [bitAction]="submit">
      {{ (permanent ? "permanentlyDelete" : "delete") | i18n }}
    </button>
    <button bitButton type="button" (click)="cancel()">{{ "cancel" | i18n }}</button>
  </ng-container>
</bit-simple-dialog>
